import React, { useContext } from "react";
import { NavLink, useParams } from "react-router-dom";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { LanguageContext } from "../context/LanguageContext";
import slugify from "react-slugify";
import translations from "../data/langData";

const CvDetails = () => {
  const { resumeId } = useParams();
  const { companyList, cvCategory } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const findCompany =
    companyList &&
    companyList.find(
      (item) =>
        slugify(`${item.id}-${item.vezife}-${item.shirket_adi}`) == resumeId
    );
  const findCategory =
    companyList &&
    cvCategory &&
    cvCategory.find((item) => item.id == findCompany.kateqoriya_id);
  const findRejim =
    findCompany && findCompany.rejim == "0"
      ? t.tamstat
      : findCompany && findCompany.rejim == "1"
      ? t.yarim
      : findCompany && findCompany.rejim == "2"
      ? t.frilans
      : findCompany && findCompany.rejim == "3"
      ? t.tecrubeci
      : findCompany && findCompany.rejim == "4"
      ? t.uzaqdan
      : findCompany && findCompany.rejim == "5"
      ? t.muveqqeti
      : "";

  const findEducation =
    findCompany && findCompany.texsil_seviyesi == "0"
      ? t.ali
      : findCompany && findCompany.texsil_seviyesi == "1"
      ? t.natamam
      : findCompany && findCompany.texsil_seviyesi == "2"
      ? t.orta
      : "";

  const findWorkExperience =
    findCompany && findCompany.texrube_seviyesi == "0"
      ? t.birildenaz
      : findCompany && findCompany.texrube_seviyesi == "1"
      ? t.birildenucileqeder
      : findCompany && findCompany.texrube_seviyesi == "2"
      ? t.ucilden5ileqeder
      : findCompany && findCompany.texrube_seviyesi == "3"
      ? t.besildencox
      : "";

  const startDate = findCompany?.created_at
    ? new Date(findCompany.created_at.split(" ")[0])
    : null; // Başlama tarixi
  const endDate = new Date(startDate); // Yeni tarix yarat
  endDate.setMonth(endDate.getMonth() + 1); // 1 ay əlavə et

  const formattedEndDate = endDate.toISOString().split("T")[0]; // Yalnız YYYY-MM-DD formatı al

  return (
    <>
      {findCompany && (
        <div
          className="cvDetails jobpostings"
          style={{ background: "#FAFAFA" }}
        >
          <div className="container-fluid">
            <div className="row g-3 p-4 py-3">
              <h4>{findCompany.vezife}</h4>
              <p>
                {t.homePage} {`>`} {t.isimkanlari} {`>`} {t.karyeramerkezi}{" "}
                {`>`} {t.karyeramerkezi1} {`>`} {findCompany.vezife}
              </p>
              <div className="col-lg-8 col-md-8 col-sm-12 col-12 ">
                <div className="detailsBox">
                  <div className="d-flex flex-wrap">
                    <div className="profile d-flex flex-wrap mx-2">
                      <img
                        src="https://www.shutterstock.com/image-vector/circle-line-simple-design-logo-600nw-2174926871.jpg"
                        alt=""
                        className="img-fluid "
                        style={{ objectFit: "contain", width: "150px" }}
                      />
                      <div className="profileJob mx-2">
                        <h4>{findCompany.vezife}</h4>
                        <p>{findCompany.shirket_adi}</p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <ul style={{ padding: "0", listStyle: "none" }}>
                    {[
                      [t.city, findCompany.seher],
                      [
                        t.kateqoriya,
                        language == "az"
                          ? findCategory.name
                          : language == "tr"
                          ? findCategory.name_tr
                          : language == "en"
                          ? findCategory.name_en
                          : language == "ru"
                          ? findCategory.name_ru
                          : language == "de"
                          ? findCategory.name_de
                          : language == "pl"
                          ? findCategory.name_pl
                          : "",
                      ],
                      [
                        t.maas,
                        findCompany.maas_min +
                          " ₼" +
                          " - " +
                          findCompany.maas_max +
                          " ₼",
                      ],
                      [t.isrejimi, findRejim],
                      [t.yerlesme, findCompany.created_at.split(" ")[0]],
                      [t.bitme, formattedEndDate],
                    ].map(([label, value]) => (
                      <li
                        className="d-flex my-2"
                        key={label}
                        style={{ alignItems: "center" }}
                      >
                        <span style={{ minWidth: "150px" }}>{label}</span>
                        <p
                          className="ms-2"
                          style={{ color: "#000", margin: 0 }}
                        >
                          {value}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
                <h5 className="my-3">{t.description}</h5>
                <ul>
                  {findCompany.is_tesviri.split("\n").map((txt, index) => (
                    <li key={index} style={{ color: "#000" }}>
                      {txt}
                    </li>
                  ))}
                </ul>
                <h5>{t.isrejimi}</h5>
                <ul>
                  <li style={{ color: "#000" }}>{findRejim}</li>
                </ul>
                <>
                  {findCompany.teleb_olunan_bacariqlar !== null && (
                    <h5>{t.telebler}</h5>
                  )}

                  <ul>
                    {findCompany.teleb_olunan_bacariqlar !== null &&
                      findCompany.teleb_olunan_bacariqlar
                        .split("\n")
                        .map((txt, index) => (
                          <li key={index} style={{ color: "#000" }}>
                            {txt}
                          </li>
                        ))}
                  </ul>
                </>
                <br />
                <h5>{t.education}</h5>
                <ul>
                  <li style={{ color: "#000" }}>{findEducation}</li>
                </ul>
                <h5>{t.istecrubesi}</h5>
                <ul>
                  <li style={{ color: "#000" }}>{findWorkExperience}</li>
                </ul>
                <button style={{ background: "#20AD96" }} className="px-4 fs-6">
                  <i className="fa-solid fa-clipboard-list"></i> {t.muraciet}
                </button>
                <h4 className="my-4">{t.oxsarvakansiya}</h4>
                <div className="allCvDetails">
                  <div className="row justify-content-center">
                    {companyList.slice(0, 3).map((item) => {
                      return (
                        <div className="col-lg-12 col-md-6 col-sm-12 col-12  my-3">
                          <div className="row g-3">
                            <>
                              <NavLink
                                to={`/resume/${slugify(
                                  `${item.id}-${item.vezife}-${item.shirket_adi}`
                                ).toLowerCase()}`}
                                id="jobLink"
                              >
                                <div
                                  className="col-lg-3 col-md-2 col-sm-12 col-12"
                                  id="cvDetails"
                                  style={{
                                    borderTop: "2px solid #f3f3f3",
                                    borderLeft: "2px solid #f3f3f3",
                                    borderBottom: "2px solid #f3f3f3",
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    background: "#fff",
                                  }}
                                >
                                  <div className=" d-flex justify-content-center align-items-center">
                                    <img
                                      src="https://www.shutterstock.com/image-vector/circle-line-simple-design-logo-600nw-2174926871.jpg"
                                      alt=""
                                      className="img-fluid"
                                      style={{ objectFit: "contain" }}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-9 col-md-10 col-sm-12 col-12"
                                  id="cvDetails"
                                  style={{
                                    borderTop: "2px solid #f3f3f3",
                                    borderRight: "2px solid #f3f3f3",
                                    borderBottom: "2px solid #f3f3f3",
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    background: "#fff",
                                  }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <h5 className="mt-3">
                                        {item.vezife}
                                        <br />
                                        <span
                                          style={{
                                            opacity: "0.5",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {item.shirket_adi}
                                        </span>
                                      </h5>
                                    </div>
                                    <div className="d-flex">
                                      <span className="heartIcon">
                                        <i class="fa-regular fa-heart"></i>
                                      </span>
                                    </div>
                                  </div>
                                  <br />
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <i
                                        class="fa-solid fa-money-bill"
                                        style={{ color: "#4CAF50" }}
                                      ></i>
                                      <span className="ms-1">
                                        {item.maas_min} ₼ - {item.maas_max} ₼
                                      </span>
                                      <div>
                                        <i
                                          class="fa-solid fa-location-dot ms-4"
                                          style={{ color: "#4CAF50" }}
                                        ></i>
                                        <span className="ms-1">Baki</span>
                                      </div>
                                    </div>

                                    <div>
                                      <span>
                                        {t.date} {item.created_at.split(" ")[0]}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </NavLink>
                            </>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 col-12 ">
                <div className="detailsBox">
                  <h5 className="text-start">
                    {t.elan} #{findCompany.id}
                  </h5>
                  <hr />
                  <div className="d-flex align-items-center">
                    <i
                      className="fa-solid fa-envelope"
                      style={{ color: "#a0aec0" }}
                    ></i>
                    <p className="ms-2" style={{ color: "#000" }}>
                      {findCompany.email}
                    </p>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <i
                      className="fa-solid fa-eye"
                      style={{ color: "#a0aec0" }}
                    ></i>
                    <p className="ms-2" style={{ color: "#000" }}>
                      447
                    </p>
                  </div>
                  <hr />
                  <span style={{ fontSize: "15px" }}>{t.kateqoriya}</span>
                  <h6 style={{ fontWeight: "normal", color: "#000" }}>
                    {findCategory.name}
                  </h6>
                  <span style={{ fontSize: "15px" }}>{t.vezife}</span>
                  <h6 style={{ fontWeight: "normal", color: "#000" }}>
                    {findCompany.vezife}
                  </h6>
                  <span style={{ fontSize: "15px" }}>{t.isrejimi}</span>
                  <h6 style={{ fontWeight: "normal", color: "#000" }}>
                    {findRejim}
                  </h6>
                </div>
              </div>
              <p>
                Turanozbahceci.az –{" "}
                <span style={{ color: "#000" }}>{t.buildcareer}</span>
              </p>
              <p>
                {t.buildcareerdesc}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CvDetails;
